import apiClient from 'src/utils/apiClient';

import { type PlacementData } from './types/placementData';

class PlacementOverviewService {
  /**
   * Get placements in open status by requester login
   */
  public async getOpenPlacementsByRequesterLogin(requesterLogin: string): Promise<{ data: PlacementData[] }> {
    return await apiClient.get(`/accommodation/open/requesterLogin/${requesterLogin}`);
  }

  /**
   * Get placements in open status by site id
   */
  public async getOpenPlacementsBySiteId(siteId: number): Promise<{ data: PlacementData[] }> {
    return await apiClient.get(`/accommodation/open/site/${siteId}`);
  }

  public async getClosedPlacementsBySiteId(siteId: number): Promise<{ data: PlacementData[] }> {
    return await apiClient.get(`/accommodation/closed/site/${siteId}`);
  }
}

export default new PlacementOverviewService();
